"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWidgetHeader = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @internal
 */
function isWidgetHeader(obj) {
    return !isEmpty_1.default(obj) && obj.title !== undefined;
}
exports.isWidgetHeader = isWidgetHeader;
//# sourceMappingURL=widgetTypes.js.map